import { Box } from "@mui/material";
import { Color, DotLegalChip } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { usePolicyVersionBadgeStyles } from "./PolicyVersionBadge.styles";

export interface PolicyVersionBadgeProps {
    version: string;
    isDraft?: boolean;
    isInitialDraft?: boolean;
    isCurrent?: boolean;
}

function PolicyVersionBadge({ version, isDraft, isInitialDraft, isCurrent }: PolicyVersionBadgeProps) {
    const { translateString } = useTranslation();
    const styles = usePolicyVersionBadgeStyles();

    if (isInitialDraft) {
        return <DotLegalChip variant="filled" size="small" color={Color.gold} value={translateString("draft")} />;
    }

    if (isDraft) {
        return <DotLegalChip variant="filled" size="small" color={Color.gold} value={`${version} → ${translateString("draft")}`} />;
    }

    const chip = <DotLegalChip variant="outlined" size="small" color={Color.lightBlue} value={version} />;

    if (!isCurrent) return chip;

    return (
        <Box sx={styles.container}>
            {chip}
            <Box sx={styles.activeBadge}>{translateString("currentVersion")}</Box>
        </Box>
    );
}

export default PolicyVersionBadge;
